import { useFlow } from "../../../FlowEdit/useFlow";
import { Select } from "antd";
import { RenderInputProps } from "../types";
import { useRef } from "react";

export default function SelectAIModel({ item, moduleId }: RenderInputProps) {
  const { updateNodeValue, llmModels } = useFlow();
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef}>
      <Select
        options={llmModels}
        defaultValue={item.value}
        onChange={(v) => {
          updateNodeValue(moduleId, item.key, v);
        }}
        getPopupContainer={(n) => containerRef.current || n}
        style={{ width: "100%" }}
        placeholder={item.placeholder}
      />
    </div>
  );
}
